import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { get } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
import { PriceDropAlertsBanner } from 'site-modules/profile/components/dashboard/price-drop-alerts-banner/price-drop-alerts-banner';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { getNewAlertsCountStatePath } from 'site-modules/shared/components/profile/price-drop-alerts/alerts-utils';
import { profileScreenMethods } from 'site-modules/shared/components/profile/profile-screen-methods';

function AlertsBannerUI({
  showPriceDropAlerts = false,
  newAlertsCount = 0,
  isAnonymousUser = null,
  hasNoEmail = true,
  className = '',
  text = 'Your account is not receiving email alerts.',
  showSetupAlertLink = false,
  toggleSignModal,
}) {
  useEffect(() => {
    EventToolbox.fireTrackAction({
      event_type: 'action_completed',
      event_data: {
        action_name: TrackingConstant.ACTION_SHOW_CONTENT,
        subaction_name: TrackingConstant.PROVIDE_MESSAGE,
        action_cause: 'page_load',
        action_category: 'system',
        creative_id: 'price-drop-alert-message',
      },
    });
  }, []);

  const showPriceDropAlertsMessage = showPriceDropAlerts && !!newAlertsCount;
  const showAlertBanner = isAnonymousUser && hasNoEmail;

  return (
    (showPriceDropAlertsMessage || showAlertBanner) && (
      <div className={classnames('alerts-banner text-gray-darker fw-medium d-flex', className)}>
        <i className="icon-bell3 mt-md-0 mt-0_25 align-self-md-center text-warning" aria-hidden />
        <div className="ms-0_5">
          {showPriceDropAlertsMessage && <PriceDropAlertsBanner />}
          {showAlertBanner && (
            <Fragment>
              {!showPriceDropAlertsMessage && text}
              {showSetupAlertLink && (
                <Button size="lg" color="link" className="p-0 text-primary-darker ms-0_25" onClick={toggleSignModal}>
                  <span className="fw-normal text-transform-none">
                    {showPriceDropAlertsMessage ? 'Sign up to receive price drop emails' : 'Sign up for alerts'}
                  </span>
                  <i className="icon-arrow-right4 ps-0_25 small" aria-hidden />
                </Button>
              )}
            </Fragment>
          )}
        </div>
      </div>
    )
  );
}

AlertsBannerUI.propTypes = {
  toggleSignModal: PropTypes.func.isRequired,
  isAnonymousUser: PropTypes.bool,
  className: PropTypes.string,
  text: PropTypes.string,
  newAlertsCount: PropTypes.number,
  showSetupAlertLink: PropTypes.bool,
  showPriceDropAlerts: PropTypes.bool,
  hasNoEmail: PropTypes.bool,
};

export const propsAreEqual = (prevProps, nextProps) => nextProps.newAlertsCount <= prevProps.newAlertsCount;

export const mapStateToProps = state => ({
  isAnonymousUser: state.profile.isAnonymousUser,
  newAlertsCount: get(state, getNewAlertsCountStatePath()),
  hasNoEmail: !get(state, 'profile.data.idm.identifiers.email[0]'),
});

export const AlertsBanner = profileScreenMethods(connect(mapStateToProps)(React.memo(AlertsBannerUI, propsAreEqual)));
